/** Product copy for canonical drop-in court tags; preserve custom tag text. */
export function formatCourtTagLabel(tag: string): string {
  return tag === "open_play" || tag === "drop_in" ? "Drop-in" : tag;
}
